import { render, staticRenderFns } from "./Accountant.vue?vue&type=template&id=57c4d06a&scoped=true"
import script from "./Accountant.vue?vue&type=script&lang=js"
export * from "./Accountant.vue?vue&type=script&lang=js"
import style0 from "./Accountant.vue?vue&type=style&index=0&id=57c4d06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4d06a",
  null
  
)

export default component.exports